<template>
	<el-dialog title="消费记录查询" :visible="visible" width="950px" center class="consume-dialog"
		@update:visible="val => $emit('update:visible', val)">
		<div class="dialog-content">
			<div class="consume-total" style="margin-bottom: 12px; font-size: 14px; color: #606266;">
				累计消费：<b style="color: #e6a23c; font-size: 18px;">{{ totalAmount }}</b> 积分
			</div>
			<!-- 消费记录筛选 -->
			<div class="filter-bar">
				<el-date-picker v-model="filter.date_range" type="daterange" range-separator="至"
					start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" clearable
					class="search-input filter-item date-range-item"></el-date-picker>
				<el-select v-model="filter.track_type" placeholder="请选择物流商" clearable
					class="search-input filter-item select-item">
					<el-option label="JCEX" :value="1"></el-option>
					<el-option label="JS" :value="2"></el-option>
					<el-option label="PIGGY" :value="3"></el-option>
				</el-select>
				<el-button type="primary" class="search-btn" @click="handleSearch">查询</el-button>
				<el-button class="reset-btn" @click="handleReset">重置</el-button>
			<el-button class="reset-btn export-btn" icon="el-icon-download" :loading="exporting"
				@click="handleExport">{{ exportLabel }}</el-button>
			</div>
			<el-table :data="records" border style="width: 100%" v-loading="loading"
				:header-cell-style="{ 
			        background: '#f5f7fa',
			        color: '#606266',
			        fontWeight: '600',
			        fontSize: '14px'
			    }">
				<el-table-column prop="id" label="ID" align="center" min-width="70"></el-table-column>
				<el-table-column prop="amount" label="消费金额" align="center" min-width="110">
					<template slot-scope="scope">
						<span style="color: #e6a23c; font-weight: 600;">-{{ scope.row.amount }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="before" label="变动前余额" align="center" min-width="110"></el-table-column>
				<el-table-column prop="after" label="变动后余额" align="center" min-width="110"></el-table-column>
				<el-table-column prop="track_type_name" label="物流商" align="center" min-width="80"></el-table-column>
				<el-table-column prop="quantity" label="数量" align="center" min-width="70"></el-table-column>
				<el-table-column prop="unit_price" label="单价" align="center" min-width="80"></el-table-column>
				<el-table-column prop="related_order_ids" label="关联订单" align="center" min-width="180">
					<template slot-scope="scope">
						<span>{{ scope.row.related_order_ids || '-' }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="remark" label="备注" align="center" min-width="160">
					<template slot-scope="scope">
						<span>{{ scope.row.remark || '-' }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="time" label="时间" align="center" min-width="160"></el-table-column>
			</el-table>

			<!-- 空数据提示 -->
			<div class="empty-recharge" v-if="records.length === 0 && !loading">
				<i class="el-icon-document" style="font-size: 40px; color: #c0c4cc; margin-bottom: 12px;"></i>
				<p style="font-size: 14px; color: #909399; margin: 0;">暂无消费记录</p>
			</div>

			<!-- 分页 -->
			<div class="recharge-pagination" v-if="total > 0">
				<el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
					:current-page.sync="currentPage" :page-size="pageSize" :page-sizes="[10, 20, 50]"
					layout="total, sizes, prev, pager, next" :total="total" small></el-pagination>
			</div>
		</div>

		<span slot="footer" class="dialog-footer">
			<el-button @click="$emit('update:visible', false)" class="dialog-btn cancel-btn"
				style="margin-right: 80px;">关闭</el-button>
			<el-button type="primary" @click="handleRefresh" class="dialog-btn refresh-btn" :loading="loading">刷新记录</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { formatDateTime as fmtDateTime } from '../utils/format';
import { exportCSV } from '../utils/export';

export default {
	name: 'ConsumeRecordsDialog',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		userId: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			loading: false,
			exporting: false,
			records: [],
			currentPage: 1,
			pageSize: 10,
			total: 0,
			totalAmount: '0.00',
			filter: {
				date_range: [],
				track_type: ''
			}
		};
	},
	watch: {
		visible(val) {
			if (val) {
				this.loadRecords(1);
			}
		}
	},
	computed: {
		exportLabel() {
			return '导出 Excel（' + this.total + '）';
		}
	},
	methods: {
		async apiRequest(url, data) {
			const response = await fetch(url, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(data)
			});
			if (!response.ok) {
				throw new Error('请求失败: ' + response.status);
			}
			return response.json();
		},
		buildParams() {
			const range = this.filter.date_range || [];
			return {
				time_start: range[0] || '',
				time_end: range[1] || '',
				track_type: this.filter.track_type
			};
		},
		async loadRecords(page) {
			if (page) this.currentPage = page;
			if (!this.userId || this.userId === 0) {
				this.$message.error('用户未登录或用户ID无效');
				return;
			}
			this.loading = true;
			try {
				const result = await this.apiRequest('/query_consume', Object.assign({
					user_id: this.userId,
					page: this.currentPage,
					page_size: this.pageSize
				}, this.buildParams()));
				if (result.code === 200) {
					this.records = this.formatData(result.data.list || []);
					this.total = result.data.count || 0;
					this.totalAmount = (parseFloat(result.data.total_amount) || 0).toFixed(2);
				} else {
					this.$message.error(result.msg || '查询失败');
				}
			} catch (error) {
				console.error('查询消费记录失败:', error);
				this.$message.error('网络错误或服务器异常，请稍后重试');
			} finally {
				this.loading = false;
			}
		},
		formatData(list) {
			const trackTypeNames = { 1: 'JCEX', 2: 'JS', 3: 'PIGGY' };
			return list.map(item => {
				return {
					id: item.id,
					amount: parseFloat(item.amount || 0).toFixed(2),
					before: parseFloat(item.before_balance || 0).toFixed(2),
					after: parseFloat(item.after_balance || 0).toFixed(2),
					track_type_name: trackTypeNames[item.track_type] || (item.track_type || '-'),
					quantity: item.quantity === null || item.quantity === undefined ? '-' : item.quantity,
					unit_price: item.unit_price === null || item.unit_price === undefined
						? '-' : parseFloat(item.unit_price).toFixed(2),
					related_order_ids: item.related_order_ids || '',
					remark: item.remark || '',
					time: fmtDateTime(item.created_at)
				};
			});
		},
		handleCurrentChange(page) {
			this.loadRecords(page);
		},
		handleSizeChange(size) {
			this.pageSize = size;
			this.loadRecords(1);
		},
		handleSearch() {
			this.loadRecords(1);
		},
		handleReset() {
			this.filter = {
				date_range: [],
				track_type: ''
			};
			this.loadRecords(1);
		},
		handleRefresh() {
			this.loadRecords(this.currentPage);
		},
		async handleExport() {
			if (this.exporting) return;
			this.exporting = true;
			try {
				const trackTypeNames = { 1: 'JCEX', 2: 'JS', 3: 'PIGGY' };
				const base = Object.assign({ user_id: this.userId, page_size: 100 }, this.buildParams());
				let all = [];
				let page = 1;
				let lastCount = 100;
				do {
					const result = await this.apiRequest('/query_consume', Object.assign({}, base, { page }));
					const d = result.data || {};
					const list = d.list || [];
					all = all.concat(list);
					lastCount = list.length;
					page++;
					// 某页不足 100 条说明已到最后一页（不依赖 total，兼容后端分页统计差异）
				} while (lastCount === 100 && page <= 1000);
				const rows = all.map((it) => [
					it.id,
					parseFloat(it.amount || 0).toFixed(2),
					parseFloat(it.before_balance || 0).toFixed(2),
					parseFloat(it.after_balance || 0).toFixed(2),
					trackTypeNames[it.track_type] || (it.track_type || '-'),
					it.quantity === null || it.quantity === undefined ? '-' : it.quantity,
					it.unit_price === null || it.unit_price === undefined ? '-' : parseFloat(it.unit_price).toFixed(2),
					it.related_order_ids || '',
					it.remark || '',
					fmtDateTime(it.created_at)
				]);
				exportCSV('消费记录_' + Date.now() + '.csv',
					['ID', '消费金额', '变动前余额', '变动后余额', '物流商', '数量', '单价', '关联订单', '备注', '时间'], rows);
			} catch (e) {
				this.$message.error('导出失败：' + e.message);
			} finally {
				this.exporting = false;
			}
		}
	}
};
</script>

<style scoped>
.consume-dialog :deep(.el-dialog) {
	border-radius: 16px;
	overflow: hidden;
}
.consume-dialog :deep(.el-dialog__header) {
	background: linear-gradient(135deg, #667eea, #764ba2);
	padding: 20px;
	text-align: center;
}
.consume-dialog :deep(.el-dialog__title) {
	color: #fff;
	font-size: 18px;
	font-weight: 600;
}
.consume-dialog :deep(.el-dialog__headerbtn .el-dialog__close) {
	color: #fff;
	font-size: 20px;
}
.consume-dialog :deep(.el-dialog__body) {
	padding: 20px;
}
.consume-dialog :deep(.el-dialog__footer) {
	padding: 15px 20px;
	border-top: 1px solid #f0f0f0;
	display: flex;
	justify-content: center;
	gap: 12px;
}
.dialog-btn.refresh-btn {
	background: linear-gradient(135deg, #667eea, #764ba2) !important;
	border: none !important;
	color: #fff !important;
}
.reset-btn.export-btn {
	background: #eaf4ff !important;
	border: 1px solid #a8c8f5 !important;
	color: #4a90e2 !important;
}
.reset-btn.export-btn:hover {
	background: #dcecff !important;
}
</style>
